/*
@ts-nocheck
 */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import _ from "lodash";

import UserApi from "../../../api/user-api";

import { Container } from "components/ui-kit/styled-templates";
import Table from "components/ui-kit/table";

import UniversityApi from "api/university-api";

import { objectToQS } from "services/common-service";

import useBodyBackground from "hooks/useBodyBackground";
import { useStorageListener } from "hooks/useStorage";
import ClubsApi from "../../../api/clubs-api";
import EventsApi from "../../../api/events-api";
import DormitoriesApi from "../../../api/dormitories-api";

// { value: `cultural`, label: `Культурно-познавательные` },
// { value: `scientific`, label: `Научно-популярные` },
// { value: `proforientation`, label: `Профориентационные` },

function getEventsLabel(allEvents, clubId) {
    console.log("getEventsLabel: clubId = ", clubId);
    let uniEvents = allEvents.filter((x) => x?.details?.clubId == clubId);
    return `${uniEvents.length}`;
}

const ClubsDashboardPage = () => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    useBodyBackground("white");

    // const university = useStorageListener(`universities`, {});
    const club = useStorageListener(`clubs`, {});
    const events = useStorageListener(`events`, {});
    console.log("UniversitiesDashboardPage: events = ", events);
    let eventsList = Object.values(events);
    console.log("UniversitiesDashboardPage: eventsList = ", eventsList);

    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);
    // @ts-ignore
    useEffect(ClubsApi.getAllClubsData, []);
    // @ts-ignore
    useEffect(EventsApi.getEvents, []);

    return (
        <Container extra="padding-top: 10px; align-items: flex-start;">
            <h2>{"Студтурклубы"}</h2>
            <Table
                name="admin-clubs-dashboard"
                withPagination={false}
                useBackendProcessing={false}
                rows={_.values(club)?.map?.((uni) => ({
                    ...uni,
                    eventsLabel: `${getEventsLabel(eventsList, uni?.id)}`,
                    number:
                        _.values(club)
                            ?.map?.((i) => i?.createdTimestamp)
                            ?.indexOf?.(uni?.createdTimestamp) + 1
                }))}
                sortable={true}
                columns={[
                    { name: `number`, label: `№`, showIndexOnClick: true },
                    { name: `id`, label: `ID` },
                    {
                        name: `details.name`,
                        label: `Название`,
                        extra: `flex: 4;`,
                        onCellClick: ({ row }) => navigate(`/club/${row?.id}`)
                    },
                    { name: `eventsLabel`, label: `События` },
                    {
                        name: `onModeration`,
                        label: `Ожидает модерации`,
                        transform: ({ row }) => (row?.onModeration ? t("igs9x5cjcfr") : t("iv9r5j6zkco"))
                    },
                    {
                        name: `menu`,
                        label: ``,
                        sortable: false,
                        extra: `flex: unset; width: 24px;`,
                        cell: {
                            type: `menu`,
                            options: [
                                { label: `Просмотр`, onClick: ({ row, navigate }) => navigate(`/club/${row.id}`) },
                                {
                                    label: `Модерация пройдена`,
                                    onClick: ({ row, navigate }) => ClubsApi.updateClub({
                                        id: row.id,
                                        onModeration: false
                                    })
                                },
                                {
                                    label: `Вернуть на модерацию`,
                                    onClick: ({ row, navigate }) => {
                                        let comment = window.prompt(`Введите комментарий для модерации`);
                                        ClubsApi.updateClub({
                                            id: row.id,
                                            onModeration: true,
                                            moderationComment: comment
                                        });
                                    }
                                }
                            ]
                        }
                    }
                ]}
            />
        </Container>
    );
};

export default ClubsDashboardPage;
